import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqCaixa = {
	listSangriaSuprimento: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/caixa/sangria-suprimento/calc", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	fechamentosPorData: async function (filterData) {
		return apiServer
			.get("portal/v1/caixa/fechamentos-por-data", {
				params: filterData,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	getFechamentoId: async function (id) {
		return apiServer
			.get(`portal/v1/caixa/fechamento/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	getFechamentoItens: async function (id) {
		return apiServer
			.get(`portal/v1/caixa/fechamento/${id}/itens`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	getFechamentoOutroCaixa: async function (id) {
		return apiServer
			.get(`portal/v1/caixa/fechamento/${id}/outro-caixa`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqCaixa;
